import { http } from '@/api/client/httpClient';
import type { PagedResult } from '@/api/types/abp';
import type { LoginActivityDatatableInput, LoginSessionDto } from '@/api/types/loginActivity';

// Routes derived from ABP conventional-controller mapping of
// Finkit.Host.LoginActivity.LoginActivityAppService:
//   GetListForDataTableAsync -> GET /api/app/login-activity/for-data-table
const BASE = '/api/app/login-activity';

export const loginActivityApi = {
  async getListForDataTable(
    input: LoginActivityDatatableInput,
  ): Promise<PagedResult<LoginSessionDto>> {
    const { data } = await http.get<PagedResult<LoginSessionDto>>(`${BASE}/for-data-table`, {
      params: input,
    });
    return data;
  },
};
